export default "/images/vendor/flag-icon-css/flags/1x1/ky.svg?914210c79b1a6f434a16cd56a5a4f451";